module.exports = __webpack_public_path__ + "img/img_T2.3.1.b29d44c7.png";